import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";

const SalesOrder = (props) => {
  const frmRef = useRef({});
  const [data, setData] = useState([]);
  const [docurl, setDocUrl] = useState(false);
  const [salesOrderId, setSalesOrderId] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setSalesOrderId(itemId);
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Sales&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        
      }
    );
  }, [getEmp]);

  const { sendRequest: getSalesOrder } = useHttp();

  useEffect(() => {
    getSalesOrder(
      {
        url: `/api/salesOrder/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          //console.log(res);
        }
      }
    );
  }, [getSalesOrder]);

  const handleEmpChange = (e) => {
    const id = parseInt(e.target.value);
    if (id) {
      getSalesOrder(
        {
          url: `/api/salesOrder/?orgId=${localStorage.getItem(
            "orgId"
          )}&fieldExecutiveId=${id}`,
        },
        (res) => {
          if (res) {
            setData(res);
            // //console.log(res);
          }
        }
      );
    }
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <h3 className="card-title mx-3 my-1">Sales Order</h3>
            </div>

            <div className="row">
              <div className="col-md-3 mx-3 my-2">
                <label htmlFor={"executive_officer"}>{"Field Executive"}</label>
                <select
                  id="emp_id"
                  className="form-control"
                  ref={(el) => (frmRef.current["emp_id"] = el)}
                  onChange={handleEmpChange}
                >
                  <option value="">Select</option>
                  {employeeData &&
                    employeeData.map((x) => (
                      <option key={x.empId} value={x.empId}>
                        {x.employeeName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3 mx-3 my-4">
                <button className="btn btn-sm btn-primary">Submit</button>
              </div>
            </div>
          </div>

          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered  text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Order Date</th>
                          <th>Sales order id</th>
                          <th>Customer Name</th>
                          <th>Contact Person Name</th>
                          <th>Total Sales order Value</th>
                          <th>Invoice Status</th>
                          <th>Sales Return</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{x.date}</td>
                                <td>{x.salesOrderCode}</td>
                                <td>{x.name}</td>
                                <td>{x.customerContactPersonName}</td>
                                <td>{x.totalSalesOrderValue}</td>
                                <td>{x.invoiceStatus}</td>
                                <td>{x.salesReturnStatus}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalesOrder;
